module.exports = __webpack_public_path__ + "30888995a47bfe33118ebb14932096e5.svg";